import React, {useCallback, useEffect, useState} from 'react';
import {CollectionList} from "../../../../components/admin/equipment/CollectionList";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {collectionResultCollectionType, collectionResultType} from "../../../../types/Api/CollectionResultType";
import {collectionHydrator} from "../../../../models/hydrator/collectionHydrator";
import {collection} from "../../../../models/collection";
import {Pagination} from "../../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Tab} from "../../../../components/admin/equipment/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [collections, setCollections] = useState([] as collection[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findCollection = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'label',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<collectionResultCollectionType> = ApiService.get('/collection', apiFilters) as Promise<collectionResultCollectionType>;

    result
      .then((r: collectionResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setCollections(r._embedded.collections.map((collection: collectionResultType) => {
          return collectionHydrator.hydrate(collection);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setCollections([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findCollection();
  }, [findCollection]);

  return (
    <>
      <BoxTitle title="Gestion de l'équipement"/>
      <Tab/>
      <CollectionList collections={collections} loading={loading} refresh={findCollection}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/equipment/collection/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une collection
        </NavLink>
      </div>
    </>
  )
}